import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './i18n/LanguageContext';

// Polyfill for older libraries that still use ReactDOM.render
declare global {
  interface Window {
    __reactRoots?: Map<Element, any>;
  }
}

// Enhanced polyfill for botframework-webchat compatibility
if (typeof window !== 'undefined') {
  window.__reactRoots = window.__reactRoots || new Map();
  
  const renderPolyfill = (element: React.ReactElement, container: Element | DocumentFragment, callback?: () => void) => {
    let root = window.__reactRoots?.get(container as Element);
    if (!root) {
      root = ReactDOM.createRoot(container as Element);
      window.__reactRoots?.set(container as Element, root);
    }
    root.render(element);
    if (callback) callback();
    return root;
  };

  // Create a complete ReactDOM polyfill object
  const ReactDOMPolyfill = {
    ...ReactDOM,
    render: renderPolyfill,
    unmountComponentAtNode: (container: Element) => {
      const root = window.__reactRoots?.get(container);
      if (root) {
        root.unmount();
        window.__reactRoots?.delete(container);
      }
      return true;
    }
  };

  // Apply polyfill to ReactDOM
  if (!(ReactDOM as any).render) {
    Object.assign(ReactDOM, { render: renderPolyfill });
  }
  
  // Make it available globally for webpack module resolution
  (window as any).ReactDOM = ReactDOMPolyfill;
  
  // Also try to patch the module system
  if (typeof require !== 'undefined' && require.cache) {
    // Attempt to patch the react-dom module in require cache
    Object.keys(require.cache).forEach(key => {
      if (key.includes('react-dom') && !key.includes('client')) {
        const module = require.cache[key];
        if (module && module.exports && !module.exports.render) {
          module.exports.render = renderPolyfill;
        }
      }
    });
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
